import { Component } from "@angular/core";
import { resetPassword, ApiResponse } from "@app/models/OTPResult";
import { ChangePassService } from "@app/services/authentication/change-pass.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

@Component({
    selector: 'app-resetPassword',
    templateUrl: './resetPassword.component.html'
})
export class ResetPasswordComponent{
    reset: resetPassword = new resetPassword();
    errorMessageNewPassword: string = '';
    errorMessageConfirmPassword: string = '';
    apiModel = new ApiResponse();
    constructor(private changePassService: ChangePassService,private toastr: ToastrService,private router: Router){

    }
    ngOnInit() {
    }

    updatePassword() {
        let emailPattern = this.reset.NewPassword
        const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#_])[A-Za-z\d@$!%*#_]{8,16}$/;
        if (!pattern.test(emailPattern)) {
            this.errorMessageNewPassword = "Enter valid password";
            return;
        }
        if (this.reset.NewPassword == this.reset.ConfirmNewPassword) {
            var tempMob = localStorage.getItem('resetMobile');
            this.reset.mobileNumber = tempMob;
            this.changePassService.updatePassword(this.reset)
                .subscribe(
                    data => {
                        this.apiModel = JSON.parse(JSON.stringify(data));
                        if (this.apiModel.Status != false) {
                            this.toastr.success(this.apiModel.SuccessMessage, 'Reset Password');
                            this.router.navigate(['/login']);
                        }
                        else {
                            this.toastr.error(this.apiModel.ErrorMessage, 'Reset Password');
                            this.errorMessageNewPassword = '';
                        }
                    });
        }
    }

    clearValidation() {
        if (this.reset.NewPassword == this.reset.ConfirmNewPassword) {
            this.errorMessageConfirmPassword = '';
        }
        else {
            this.errorMessageConfirmPassword = 'Password does not match';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/customer-login/resetPassword.component.ts